import styled, { StyledComponentProps } from 'styled-components'
import { NoSelectStyles } from '../shared/styled/NoSelectStyles.styled'

interface IProps {
    active?: boolean
}

export const StyledAddedToQueueIcon = (props: IProps & StyledComponentProps<'svg', any, {}, never>) => {
    return (
        <StyledSvg viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path d="M22.5 6.56253L15 6.56253" strokeWidth="1.14102" strokeLinecap="round" />
            <path d="M14.9443 20.625L6.50684 20.625" strokeWidth="1.14102" strokeLinecap="round" />
            <path d="M22.5 18.75L18.75 22.5" strokeWidth="1.14" strokeLinecap="round" />
            <path d="M18.75 22.5L16.875 20.625" strokeWidth="1.14" strokeLinecap="round" />
            <path d="M22.5 15.9375L6.5625 15.9375" strokeWidth="1.14102" strokeLinecap="round" />
            <path d="M24 11.25L7 11.25" strokeWidth="1.14102" strokeLinecap="round" />
        </StyledSvg>
    )
}

const StyledSvg = styled.svg<IProps>`
    ${NoSelectStyles}

    width: 30px;
    height: 30px;
    stroke: ${p => p.theme.playColor};
`
